import { Checkbox, Flex, Select, Text } from "@gravity-ui/uikit";
import { CreateExportTaskRequestDto } from "definitions/exporter";
import { useCallback } from "react";
import { Controller, useFormContext } from "react-hook-form";

const DAYS = [
  "Воскресенье",
  "Понедельник",
  "Вторник",
  "Среда",
  "Четверг",
  "Пятница",
  "Суббота",
];

interface CronFromProps {
  isView: boolean;
  setIsView: React.Dispatch<React.SetStateAction<boolean>>;
}

export const CronForm = ({ isView, setIsView }: CronFromProps) => {
  const { control, watch, setValue } =
    useFormContext<CreateExportTaskRequestDto>();

  const cronTask = watch("cronTask");

  const handleSetView = useCallback(
    (value: boolean) => {
      if (value) {
        setValue("cronTask", { everyType: 0, weekDays: [] });
      } else {
        setValue("cronTask", undefined);
      }

      setIsView(value);
    },
    [setIsView, setValue],
  );

  return (
    <Flex direction={"column"} gap={4}>
      <Flex gap={4} alignItems={"center"}>
        <Checkbox checked={isView} size="l" onUpdate={handleSetView}>
          <Text>Повторять выгрузку по расписанию</Text>
        </Checkbox>
      </Flex>

      {isView && (
        <Flex alignItems={"center"} gap={2}>
          <Controller
            name="cronTask.everyType"
            defaultValue={0}
            control={control}
            render={({ field }) => (
              <>
                <Text>{field.value ? "Каждую" : "Каждый"}</Text>
                <Select
                  {...field}
                  width="auto"
                  value={
                    field.value !== undefined ? [field.value.toString()] : []
                  }
                  onUpdate={(value) => field.onChange(Number(value[0]))}
                >
                  <Select.Option value="0" key="day">
                    день
                  </Select.Option>
                  <Select.Option value="1" key="week">
                    неделю
                  </Select.Option>
                </Select>
              </>
            )}
          />
          <Controller
            name="cronTask.weekDays"
            defaultValue={[]}
            control={control}
            render={({ field }) => (
              <>
                {cronTask?.everyType === 1 && (
                  <>
                    <Text>в</Text>
                    <div style={{ maxWidth: 200, width: "100%" }}>
                      <Select
                        {...field}
                        multiple
                        value={field.value ? field.value.map(String) : []}
                        placeholder="Выберите дни недели"
                        onUpdate={(value) => {
                          const updateValues = value
                            .map(Number)
                            .filter(Number.isInteger)
                            .sort((a, b) => a - b);

                          field.onChange(updateValues);
                        }}
                        hasClear
                        width="max"
                      >
                        {DAYS.map((day, index) => {
                          return (
                            <Select.Option
                              value={index.toString()}
                              key={`cronDay.${index}`}
                            >
                              {day}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </div>
                  </>
                )}
              </>
            )}
          />

          <Text>в 00:00</Text>
        </Flex>
      )}
    </Flex>
  );
};
